import { merge } from 'lodash';
import view from './view.json';
import { replace } from './replace';

export const english = merge(view, replace);
